import { DownloadPageLayout } from '@bpm-web-app/components';
import { VideosPerCategory } from '@bpm-web-app/components/pages';

export default function Academy({ title }: { title: string }) {
    return (
        <DownloadPageLayout title={title}>
            <VideosPerCategory />
        </DownloadPageLayout>
    );
}

export async function getStaticProps() {
    return {
        props: {
            title: 'BPM Academy',
        },
    };
}
